module.exports = __webpack_public_path__ + "img/bbb.237169f6.png";